<template>
  <div>
    <div v-show="load && showContent">
      <v-skeleton-loader type="article"></v-skeleton-loader>
    </div>
    <div v-show="!load || !showContent">
      <div v-if="showContent">
        <div v-for="group in groups">
          <h5 class="text-center" :gid="group.id">
            {{ group.name }}
            <v-icon size="x-small" icon="mdi-content-copy" @click="copyTableToClipboard(group)" />
          </h5>
          <v-data-table class="curatorGradeTable" :headers="group.discHeaders" :items="group.discItems"
            :hide-default-footer="true" :items-per-page="-1">
            <template v-slot:item="{ item }">
              <tr>
                <td>
                  <a target="_blank"
                    :href="$model.wwwroot + '/blocks/manage_groups/personal/personal-card.php?user_id=' + item.id">
                    {{ item.fio }}
                  </a><br />
                  Последний вход:{{ item.lastaccess}}
                </td>
                <td v-for="discipline in item.disciplines" :key="discipline.id" :discid="discipline.id">
                  <div v-if="discipline.grades.length">
                    <span v-for="grade in discipline.grades" :gradeid="grade.id"
                      :class="'cursor-pointer mr-1 ' + gradeTypeColorMap[grade.type] ?? 'text-purple'">
                      {{ grade.finalgrade }}
                      <v-tooltip activator="parent" location="top">{{ grade.itemname }} {{ grade.date }}</v-tooltip>
                    </span>
                  </div>

                  <div v-if="discipline.attendance.length" class="cursor-pointer">
                    Пропусков:{{ discipline.attendance.length }}
                    <v-tooltip activator="parent" location="top">
                      <span class="mr-1" v-for="att in discipline.attendance" :key="att.id">
                        {{ att.date.substring(5) }}
                      </span>
                    </v-tooltip>
                  </div>
                </td>
              </tr>
            </template>
            <template v-slot:bottom> </template>
          </v-data-table>
        </div>
      </div>
      <div v-if="!showContent" class="cursor-pointer">
        <v-col class="d-flex flex-column align-center">
          <v-icon color="info" icon="mdi-school"></v-icon>
        </v-col>

        <v-col style="word-break: break-word" class="d-flex flex-column align-center">
          <span>Классное руководство</span>
        </v-col>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    //поле data из psm_desktop_widgets
    data: {
      required: true,
    },
    showContent: {
      default: false,
      type: Boolean
    }
  },
  name: "curatorWidget",
  data() {
    return {
      groups: [],
      load: false,
      gradeTypeColorMap: {
        grade: "text-blue",
        quiz: "text-blue",
        finalgrade: "text-red",
        exam: "text-yellow",
        attestat: "text-yellow"
      },
    };
  },
  watch: {
    showContent: function (newVal) {
      if (newVal && this.groups.length == 0) {
        this.loadData();
      }
    }
  },
  created() {
    if (!this.showContent) {
      return
    }
    this.loadData();
  },
  methods: {
    loadData() {
      this.load = true;

      this.axios
        .post(
          this.$model.wwwroot + "/procollege/psm_desktop2/widgets/curatorReport/get"
        )
        .then((response) => {
          response.data.forEach(group => {
            let headers = [{
              title: "ФИО",
              align: "center",
              key: "fio"
            }];
            let items = [];

            group.grades.forEach((discipline, discIndex) => {
              headers.push({
                title: discipline.name,
                align: "center",
                id: discipline.id,
                key: "discid" + discipline.id
              })
              //----------------------------

              discipline.users.forEach((student, studentIndex) => {
                let item = {};
                if (discIndex == 0) {
                  item = {
                    "fio": student.lastname + " " + student.firstname,
                    "id": student.student_id,
                    "disciplines": [],
                    "lastaccess": student.lastaccess
                  }
                }
                else {
                  item = items[studentIndex];
                }

                item["disciplines"].push({ "grades": student.grades, "attendance": student.attendance, "id": discipline.id });
                items[studentIndex] = item;
              });
            });
            group.discHeaders = headers;
            group.discItems = items;
            delete group.grades
          });

          this.groups = response.data;
          this.load = false;
        })
        .catch((error) => {
          this.load = false;
          console.log(error);
        });

    },
    copyTableToClipboard(group) {
      // 1. Заголовки (берём из group.discHeaders)
      const headers = group.discHeaders.map(h => h.title || h.key).join('\t');

      // 2. Данные строк
      const rows = group.discItems.map(item => {
        const rowData = [];

        // Первая колонка: ФИО + Последний вход
        rowData.push(`${item.fio} (Вход: ${item.lastaccess})`);

        // Проходим по дисциплинам (как в вашем v-for="discipline in item.disciplines")
        if (item.disciplines) {
          item.disciplines.forEach(discipline => {
            let cellContent = [];

            // Собираем оценки
            if (discipline.grades && discipline.grades.length) {
              const grades = discipline.grades.map(g => g.finalgrade).join(', ');
              cellContent.push(`Оценки: ${grades}`);
            }

            // Собираем пропуски
            if (discipline.attendance && discipline.attendance.length) {
              cellContent.push(`Пропусков: ${discipline.attendance.length}`);
            }

            rowData.push(cellContent.join(' | ')); // Разделитель внутри одной ячейки Excel
          });
        }

        return rowData.join('\t');
      }).join('\n');

      const resultText = `${headers}\n${rows}`;

      // 3. Копирование
      navigator.clipboard.writeText(resultText)
        .then()
        .catch(err => console.error('Ошибка:', err));
    }

  },
};
</script>
<style lang="scss">
#procollege_desktop2 {
  .curatorGradeTable {

    table>tbody>tr>td:nth-child(1),
    table>thead>tr>th:nth-child(1) {
      position: sticky !important;
      position: -webkit-sticky !important;
      left: 0;
      z-index: 9998;
      background: white;
    }

    table>thead>tr>th:nth-child(1) {
      z-index: 9999;
    }
  }
}
</style>
